const tileGrid = {

    elements: {},

    getElementHeight(tile)
    {
        const rect = tile.getBoundingClientRect();
        return rect.height;
    },

    resizeFeaturedTile()
    {
        const mq = window.matchMedia( '(min-width: 960px)' );
        let imageHeight = 'auto';

        if( mq.matches )
        {
            const lastTile = this.elements.tiles.item(2);
            const overallHeight = this.getElementHeight(this.elements.container);
            const lastTileCaption = lastTile.querySelector('.tile-grid__caption');
            const captionHeight = lastTileCaption.offsetHeight;
            const lastTileStyle = window.getComputedStyle(lastTile);
            const lastTileBottomMargin = parseInt(lastTileStyle.marginBottom);
            
            imageHeight = (overallHeight - captionHeight - lastTileBottomMargin) + 'px';
        }

        this.elements.container.style.setProperty('--js-main-tile-height', imageHeight);
    },

    resizeTileGridImages()
    {
        Array.prototype.forEach.call( this.elements.tileGridItems, (item) => {
            const image = item.querySelector('img');

            if( image )
            {
                const rect = item.getBoundingClientRect();
                const width = rect.width;
                const height = width / 1.5;

                image.style.height = `${height}px`;
            }
        });
    },

    cacheDom()
    {
        this.elements.container = document.querySelector('.js-featured-tile');
        if( this.elements.container )
        {
            this.elements.tiles = this.elements.container.children;
        }

        this.elements.tileGridItems = document.querySelectorAll('.js-tile-grid-item');
    },

    onResize()
    {
        if( this.elements.container ) {
            this.resizeFeaturedTile();            
        }

        // if( this.elements.tileGridItems ) {
        //     this.resizeTileGridImages();            
        // }
    },

    bind()
    {
        window.addEventListener('resize', () => {
            this.onResize();
        });
    },
    
    init() {
        this.cacheDom();
        this.bind();
        this.onResize();
    }
}

export default tileGrid;